import { styled } from '@mui/material';

export const StyledLessonDescriptionDetailsWrap = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	padding: '21px 6px',
	gap: '12px',
});
